import {Validate} from "@/utils";
import {FC,ReactNode} from "react";

interface ErrorsProps {
    validation: any;
    fieldName: string;
  }

const Errors:FC<ErrorsProps>= (props: ErrorsProps) => {

    const { validation, fieldName } = props;
    const state = validation?.state;
    const children: ReactNode[] = [];
    if (!state?.approval.failed || !state?.dirty) {
      return '';
    }
    const errors = Validate.errors(validation);
    errors.forEach((error: any) => {
      let i = 0;
      children.push(
        <p
          className="mb-0"
          id={`error-${fieldName}-${error.rule}-${i}`}
          key={`${error.rule}-${i}`}
        >
          {error.message}
        </p>,
      );
      i++
    });
    return children.length ? (
      <div className={`error-message`} id={`error-${fieldName}-validation`}>
        {children}
      </div>
    ) : (
      ''
    );
};

export default Errors;